<!-- Working Schedule -->
<div class="trezo-card working-schedule-card bg-white dark:bg-[#0c1427] p-[25px] md:p-[25px] rounded-md border-2 border-sky-600 shadow">
  <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-center">
    <div class="trezo-card-title">
      <h5 class="!mb-0 text-sm text-sky-600">
        Training Schedule
      </h5>
    </div>
  </div>
  <div class="trezo-card-content relative">
    <div class="calendar">
      <div class="header flex items-center justify-between mb-[20px]">
        <button (click)="previousMonth()" class="transition-all text-black bg-gray-100 dark:text-white dark:bg-[#172036] flex items-center justify-center rounded-full w-[30px] h-[30px] hover:bg-sky-500 hover:text-white">
          <i class="material-symbols-outlined rtl:-scale-x-[1]">
            chevron_left
          </i>
        </button>
        <span class="block font-medium text-black dark:text-white">
          {{ monthNames[currentMonth] }} {{ currentYear }}
        </span>
        <button (click)="nextMonth()" class="transition-all text-black bg-gray-100 dark:text-white dark:bg-[#172036] flex items-center justify-center rounded-full w-[30px] h-[30px] hover:bg-sky-500 hover:text-white">
          <i class="material-symbols-outlined rtl:-scale-x-[1]">
            chevron_right
          </i>
        </button>
      </div>
      <div class="weekdays grid grid-cols-7 mb-[6px] text-center">
        @for (day of weekdays; track day) {
          <div class="text-black dark:text-white font-medium">
            {{ day }}
          </div>
        }
      </div>
      <div class="days grid grid-cols-7 text-center">
        @for (day of daysInMonth; track day) {
          <div
            class="w-[32px] h-[32px] cursor-pointer leading-[31px] rounded-full my-[7px] mx-auto"
            [ngClass]="{ 'current-day': isToday(day) }"
            >
            @if (day !== null) {
              <span>
                {{ day }}
              </span>
            }
            @if (day === null) {
              <span>
                &nbsp;
              </span>
              } <!-- Placeholder for empty days -->
            </div>
          }
        </div>
      </div>
      <div class="mt-[19px] relative">
        <!-- <span class="block mb-[14px] font-medium">
          Upcoming Events:
        </span> -->
        <!-- <owl-carousel-o [options]="upcomingEventsSlides">
          <ng-template carouselSlide>
            <div class="relative ltr:pl-[14px] rtl:pr-[14px]">
              <div class="absolute ltr:left-0 rtl:right-0 top-[4px] w-[7px] h-[7px] rounded-sm bg-primary-500"></div>
              <h6 class="!text-sm !mb-[5px] !font-semibold">
                Pythons Unleashed: A Development Expedition
              </h6>
              <span class="text-xs">
                <span class="text-primary-500">
                  15 April 2025
                </span>
                - 12.00 PM - 6.00 PM
              </span>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="relative ltr:pl-[14px] rtl:pr-[14px]">
              <div class="absolute ltr:left-0 rtl:right-0 top-[4px] w-[7px] h-[7px] rounded-sm bg-primary-500"></div>
              <h6 class="!text-sm !mb-[5px] !font-semibold">
                Pythons Unleashed: A Development Expedition
              </h6>
              <span class="text-xs">
                <span class="text-primary-500">
                  15 April 2025
                </span>
                - 12.00 PM - 6.00 PM
              </span>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="relative ltr:pl-[14px] rtl:pr-[14px]">
              <div class="absolute ltr:left-0 rtl:right-0 top-[4px] w-[7px] h-[7px] rounded-sm bg-primary-500"></div>
              <h6 class="!text-sm !mb-[5px] !font-semibold">
                Pythons Unleashed: A Development Expedition
              </h6>
              <span class="text-xs">
                <span class="text-primary-500">
                  15 April 2025
                </span>
                - 12.00 PM - 6.00 PM
              </span>
            </div>
          </ng-template>
        </owl-carousel-o> -->
      </div>
      <div class="flex items-center justify-content-end">
        <button type="button" class="signin" (click)="toggleClass()">
          <span class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] text-sm">
            <i class="material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2">
              add
            </i>
            Add Training
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Add New Popup -->
  <div
    class="add-new-popup z-[999] fixed transition-all inset-0 overflow-x-hidden overflow-y-auto lg:py-[20px]"
    [class.active]="classApplied"
    >
    <div class="popup-dialog transition-all mx-auto">
        <div class="trezo-card flex space-between mb-1">
          <!-- <div class="trezo-card-title">
            <span class="!mb-0 text-lg font-medium text-sky-600">
              Add Training
            </span>
          </div> -->
          <div class="trezo-card-subtitle w-full text-right">
            <button type="button" class="text-[43px] text-semibold transition-all leading-none text-black dark:text-white hover:text-primary-500" (click)="toggleClass()">
              <i class="ri-close-fill"></i>
            </button>
          </div>
        </div>
        <div class="trezo-card-content">
          <form>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div class="sm:col-span-2">
                <label class="mb-[10px] text-black dark:text-white font-medium block text-base">
                  Add title
                </label>
                <input type="text" class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500" placeholder="Add title">
              </div>
              <div>
                <label class="mb-[10px] text-black dark:text-white font-medium block">
                  Start Date
                </label>
                <input type="date" class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500">
              </div>
              <div>
                <label class="mb-[10px] text-black dark:text-white font-medium block">
                  End Date
                </label>
                <input type="date" class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500">
              </div>
            </div>
            <div class="flex gap-x-4 justify-content-center mt-4 pb-2">
              <button type="button" (click)="toggleClass()" class="bg-red-600 text-white text-semibold py-1 px-2 round-md">
                <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] text-sm">
                  <i class="material-symbols-outlined !text-[20px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2">
                    close
                  </i>
                  Cancel</span>
              </button>
              <button type="button" class="bg-sky-600 text-white text-semibold py-1 px-2 round-md">
                <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] text-sm">
                  <i class="material-symbols-outlined !text-[20px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2">
                    add
                  </i>
                  Create
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
